import { useEffect, useState } from "react";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

const useProfilePicture = (
  account: AccountInfo | undefined,
  instance: IPublicClientApplication,
) => {
  const [profilePictureUrl, setProfilePictureUrl] = useState<string | null>(
    null,
  );
  const [loadingProfilePicture, setLoadingProfilePicture] = useState(false);

  useEffect(() => {
    const fetchProfilePicture = async () => {
      if (!account) return;

      setLoadingProfilePicture(true);
      try {
        const silentRequest = {
          scopes: ["User.Read"],
          account: account,
        };

        const response = await instance.acquireTokenSilent(silentRequest);

        const graphResponse = await fetch(
          "https://graph.microsoft.com/v1.0/me/photo/$value",
          {
            headers: {
              Authorization: `Bearer ${response.accessToken}`,
            },
          },
        );

        if (graphResponse.ok) {
          const blob = await graphResponse.blob();
          const imageUrl = URL.createObjectURL(blob);
          setProfilePictureUrl(imageUrl);
        }
      } catch (error) {
        console.log("Failed to fetch profile picture:", error);
      } finally {
        setLoadingProfilePicture(false);
      }
    };

    fetchProfilePicture();
  }, [account, instance]);

  return { profilePictureUrl, loadingProfilePicture };
};

export default useProfilePicture;
